import * as React from "react";
const SvgSizeLg = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: 20, height: 20, fill: "none", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 15.833, height: 15.833, x: 2.083, y: 2.083, stroke: "currentColor", strokeWidth: 1.25, rx: 7.917 }));
export default SvgSizeLg;
